import React, {type ReactElement} from "react";

export default function IssueOpenMark ({text}: {text: string}): ReactElement {
    return <div className={'d-flex justify-content-center'}>
        <div className={'badge bg-white color-black padding-1 fs-6'}>
            Support request opened · {text}
        </div>
    </div>
}
